import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  root: {
    maxWidth: 250,
  },
  media: {
    height: 150,
    width: 250,
    marginTop: '10%',
  },
  flex: {
    display: "flex",
    flexDirection: "column",
    color: "black"
  }
}));